var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"contact-list__new-contact-button button",attrs:{"to":"/new"}},[_vm._v(" Добавить контакт ")])}
var staticRenderFns = []

export { render, staticRenderFns }